import React from 'react';
import { observer } from 'mobx-react-lite';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { useAppStateContext } from 'src/AppState/AppState';
import { lpBannerOptions } from '../NotificationPageForm/selectionOptions';
import { OldSelect } from 'src/domains/layouts/shared/formComponents/Select/components/OldSelect';
import { UploadImg } from 'src/components/UploadImg/UploadImg';
import { SectionHeaderLabel } from 'src/domains/layouts/shared/cms/form/Form.style';

export const Banners = observer(() => {
    const { notificationPageState } = useAppStateContext();
    const { isHTMLBannerType, mediaType, HTMLUrl, HTMLUrlModel } = notificationPageState;

    return (
        <>
            <SectionHeaderLabel>Banner Assets</SectionHeaderLabel>
            <OldSelect selectOptions={lpBannerOptions} stateValue={mediaType} dataTest='set-banner'/>

            {isHTMLBannerType ? (
                <OldInput label='HTML5 banner link' formInputState={HTMLUrl} model={HTMLUrlModel}/>
            ) : (
                <UploadImg
                    title='Choose artwork for static banner'
                    uploadImageState={notificationPageState.uploadImageState}
                />
            )}
        </>

    );
});
